// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__WeQCz","footer":"Form_footer__3kYsO"};